export default __webpack_public_path__ + "static/media/doner_logo_17kerulet.2bf91e20.png";